import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button, Zoom, InputAdornment, IconButton, Avatar, TextField } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { changeStepper } from "../../../../actions/preAfiliado/stepper";
import { useDispatch, useSelector } from "react-redux";
import { useValidation } from "../../../../hooks/useValidation";
import LogoAFIP from "../../../../assets/AFIPlogo.png";
import { finishAlerta, startAlerta } from "../../../../actions/ui/alertas";
import { empresaLimpiar, empresaTraerAFIPSuccess, fetchAFIP } from "../../../../actions/empresas/empresas";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  botonera: {
    marginTop: 25,
  },
  NroAfi: {
    fontSize: 15,
  },
  hideButton: {
    display: "none",
  },
  fab: {
    position: "relative",
    top: theme.spacing(2),
    left: theme.spacing(15),
  },
  iconSmall: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  empresaEncontrada: {
    fontWeight: "bold"
  }
}));

const mensajeIngresoBruto = "¿Cuál es su ingreso mensual bruto? (El bruto es el que figura SIN los descuentos)"

export const FormularioEmpresaPreAfiliadoWeb = ({ form }) => {

  const classes = useStyles();
  const dispatch = useDispatch()
  const { step } = useSelector((state) => state.stepper);
  const { empresa } = useSelector((state) => state.empresas);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleSubmit = (e) => {
    e.preventDefault();
    empresa.denominacion ? dispatch(changeStepper(step + 1)) :
      dispatch(
        startAlerta(
          `La Empresa Es Requerida`,
          "error",
          "Error"
        )
      )
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const [valuesValidation] = useValidation(form?.formValues);

  const handleCUITChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    if (e.target.value === "" || reg.test(e.target.value)) {
      form?.setearValor("cuit_Empresa", e.target.value);
    }
  };

  const handleCuitAFIP = async () => {
    if (form?.formValues?.cuit_Empresa?.toString().length === 11) {
      dispatch(startSpinner());
      dispatch(startAlerta(`Buscando empresa...`, "info"))
      const empresaAFIP = await dispatch(fetchAFIP(form.formValues.cuit_Empresa));
      if (empresaAFIP) {
        dispatch(empresaTraerAFIPSuccess(empresaAFIP));
        dispatch(finishAlerta())
      } else {
        dispatch(
          startAlerta(
            `Empresa no encontrada en AFIP`,
            "error",
            "Verifique CUIT"
          )
        )
      }
      dispatch(finishSpinner());
    } else {
      dispatch(
        startAlerta(
          `El CUIT ingresado debe contener 11 digitos`,
          "error",
          "Verifique CUIT"
        )
      );
    }
  };

  return (
    <Zoom style={{ transitionDelay: "100ms" }} in={true}>
      <ValidatorForm onSubmit={handleSubmit}>
        <div className={classes.root}>
          <Grid container spacing={1} justify="center">
            <Grid item xs={7}>
              <TextField
                margin="normal"
                fullWidth
                label="CUIT"
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={(e) => {
                  form?.formValues?.cuit_Empresa?.length === 0 && handlePopoverOpen(e);
                }}
                onMouseLeave={handlePopoverClose}
                onFocus={handlePopoverClose}
                onClick={handlePopoverClose}
                name="cuit"
                error={valuesValidation["cuit"]}
                helperText={
                  valuesValidation["cuit_Empresa"] && "Obligatorio con 11 caracteres"
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      {empresa.denominacion ?
                        (
                          <>
                            <Typography className={classes.empresaEncontrada}>{empresa.denominacion}</Typography>
                            <IconButton onClick={() => dispatch(empresaLimpiar())}>
                              <CancelIcon
                                className={classes.iconSmall}
                              ></CancelIcon>
                            </IconButton>
                          </>
                        ) : (
                          <IconButton onClick={() => handleCuitAFIP()}>
                            <Avatar
                              className={classes.iconSmall}
                              src={LogoAFIP}
                            ></Avatar>
                          </IconButton>
                        )}
                    </InputAdornment>
                  ),
                }}
                value={form?.formValues?.cuit_Empresa}
                autoComplete="off"
                autoFocus
                onChange={(e) => {
                  handleCUITChange(e);
                }}
                inputProps={{
                  maxLength: 11,
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} justify="center">
            <Grid item xs={8} style={{ marginTop: "1em" }}>
              <Typography variant="h6">{mensajeIngresoBruto}</Typography>
            </Grid>
            <Grid item xs={8}>
              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="Ingreso Bruto"
                name="ingreso_Bruto"
                disabled={false}
                value={form?.formValues?.ingreso_Bruto || ""}
                autoComplete="off"
                type="number"
                validators={["required"]}
                errorMessages={["El ingreso es requerido."]}
                onChange={(e) => form?.setearValor("ingreso_Bruto", e.target.value)}
              />
            </Grid>
          </Grid>
          <Button id="btnsubmitEmpresa" className={classes.hideButton} type="submit">
            Submit
          </Button>
        </div>
      </ValidatorForm>
    </Zoom>
  );
};